import actions from "@iso/redux/user/actions";
import authActions from "@iso/redux/auth/actions";

const initialState = {
  me: null,
  status: 'idle',
  error: null,
};

export default function userReducer(state = initialState, action) {
 switch (action.type) {
   case actions.GET_USER_PROFILE:
     return {
       ...state,
       status: 'loading',
       error: null,
     };
   case actions.GET_USER_PROFILE_SUCCESS:
     return {
       ...state,
       me: action.payload,
       status: 'succeeded',
       error: null,
     }
   case actions.GET_USER_PROFILE_ERROR:
     return {
       ...state,
       status: 'failed',
       error: action.payload,
     }
   case authActions.LOGOUT:
     return initialState;
   default:
     return state;
 }
}

